import { render, staticRenderFns } from "./SpecialCaseDetail.vue?vue&type=template&id=1b90918c&scoped=true&"
import script from "./SpecialCaseDetail.vue?vue&type=script&lang=js&"
export * from "./SpecialCaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90918c",
  null
  
)

export default component.exports